import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { BaseResponseModel, IParticipant, IParticipantIsSelected, IReceiver } from "src/app/shared";
import { environment } from "src/environments/environment";

@Injectable()
export class ParticipantService {
  private BASE_URL = environment.base_url;
  constructor(private http: HttpClient) { }

  getAllForSelect(): Observable<BaseResponseModel<IParticipant[]>> {
    const apiUrl = `${this.BASE_URL}participants/select`;

    return this.http.get<BaseResponseModel<IParticipant[]>>(apiUrl);
  }

  chooseParticipant(participantId: string): Observable<BaseResponseModel<IParticipantIsSelected[]>> {
    const apiUrl = `${this.BASE_URL}participants/${participantId}/choose`;

    return this.http.get<BaseResponseModel<IParticipantIsSelected[]>>(apiUrl);
  }

  chooseReceiver(participantId: string): Observable<BaseResponseModel<IReceiver[]>> {
    const apiUrl = `${this.BASE_URL}participants/${participantId}/receiver`;

    return this.http.get<BaseResponseModel<IReceiver[]>>(apiUrl);
  }

  sendSMS(phoneNumbers: string[]): Observable<BaseResponseModel<string>> {
    const apiUrl = `${this.BASE_URL}participants/sms`;
    return this.http.post<BaseResponseModel<string>>(apiUrl, phoneNumbers);
  }
}
